import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environment/environment';

export interface CprngFeatureAccessRow {
  enabled: boolean;
  via: string | null;
  organizations_id: number | null;
}

/**
 * Effective CPRNG feature access for the authenticated user.
 * GET /users/cprng-features
 */
export function cprng_features(
  service: ComponentDataSourceService
): DataSourceFunction {
  return {
    name: 'cprng_features',
    description: 'CPRNG product feature access for current user',
    execute: (
      _params?: LoadDataParams
    ): Observable<{ features: Record<string, CprngFeatureAccessRow> }> => {
      return service.http
        .get<{ features: Record<string, CprngFeatureAccessRow> }>(
          `${environment.apiUrl}/users/cprng-features`,
          { withCredentials: true }
        )
        .pipe(map((res) => ({ features: res.features ?? {} })));
    },
  };
}
